
const ExpectationsSection = () => {
  const expectations = [
    {
      icon: 'ri-lock-line',
      title: 'Complete Confidentiality',
      description: 'Your business information stays private. We sign NDAs and handle all discussions with the utmost discretion.'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Straight Talk',
      description: 'We believe in honest, direct communication. No sales pressure, no unrealistic promises. Just clear, straightforward conversation.'
    },
    {
      icon: 'ri-time-line',
      title: 'Respect for Your Time',
      description: 'We know you\'re busy running your business. Our process is efficient and designed to minimize disruption to your operations.'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Fair Treatment',
      description: 'Every interaction is based on mutual respect. We treat you as a partner, not just a transaction.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl font-bold text-navy mb-4">
            What Owners Can Expect
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Working with us means working with professionals who understand the weight of what you're considering and treat it accordingly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {expectations.map((expectation, index) => (
            <div key={index} className="flex items-start space-x-4 p-6 rounded-lg hover:bg-soft-gray transition-colors duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                <i className={`${expectation.icon} text-white text-xl`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-navy mb-3 text-lg">{expectation.title}</h3>
                <p className="text-gray-600 leading-relaxed">{expectation.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-soft-gray rounded-lg p-8 max-w-4xl mx-auto">
            <h3 className="font-playfair text-2xl font-semibold text-navy mb-4">
              No Obligation, No Pressure
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Our initial conversations are always exploratory. There's no commitment required, no fees upfront, and no pressure to move forward. We're here to provide information and options—the decision is always yours.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpectationsSection;
